/**
 * Display labels for Airtable's `Site Type` values.
 *
 * The stored values carry explanatory parentheticals — "Sacred spaces (churches,
 * synagogues, temples)", "Libations (breweries, distilleries, etc)" — which are
 * useful to editors but too long for a tag on a card. CAC also has mosques and
 * cemeteries, so the Sacred list was actively misleading (Asana O2-24).
 *
 * This is display-only on purpose. `Site Type` is the value the site-type filter
 * matches on and the value that travels in the ?siteTypeFilters= query, so the
 * raw string has to stay exactly as Airtable stores it — renaming the option in
 * Airtable instead would break saved links and any comparison against it.
 */
const SITE_TYPE_LABELS: Record<string, string> = {
    'Sacred spaces (churches, synagogues, temples)': 'Sacred Sites',
};

export const siteTypeLabel = (value?: string | null): string => {
    if (!value) return '';
    const exact = SITE_TYPE_LABELS[value.trim()];
    if (exact) return exact;
    // Anything else keeps its name minus the parenthetical.
    return value.replace(/\s*\([^)]*\)\s*$/, '').trim();
};
